import React, { useState } from "react";
import "../Video/Video.css";

const VideoSection = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="video-section">
      <div className="video-thumbnail">
        {/* Strip Image */}
        <div className="top-strip">
          <img src="/lg.webp" alt="Strip" />
        </div>

        {/* Overlay with Play Button and Text */}
        <div className="overlay">
          <div className="content-center">
            <div className="play-circle" onClick={() => setShowVideo(true)}>
              <div className="triangle"></div>
            </div>
            <h2 className="video-title">Take a Tour</h2>
            <p className="video-desc">
              We can provide corporate governance, helping clients manage the
              responsibilities of running a corporation in financial field.
            </p>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div className="video-popup">
          <div className="video-container">
            <span className="close-btn" onClick={() => setShowVideo(false)}>
              &times;
            </span>
            <iframe
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ"
              title="Video Player"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSection;
